class StickyAddToBasket {

    shopifyProductForm = null;
    elements = {};

    constructor(wrapper) {
        if(typeof shopifyProductForm == 'undefined' || typeof shopifyProductForm[0] == 'undefined') {
            return;
        }
        this.shopifyProductForm = shopifyProductForm[0];
        this.loadElements(wrapper);
        this.setEventListeners();
    }

    loadElements(wrapper) {
        this.elements.wrapper = wrapper;
        this.elements.quantityInput = wrapper.find('.quantity--input__input');
        this.elements.incrementQuantity = wrapper.find('.quantity--input__button.quantity--input__decr');
        this.elements.decrementQuantity = wrapper.find('.quantity--input__button.quantity--input__incr');
        this.elements.submit = wrapper.find('.sticky-add-to-basket__submit');
    }

    setStateToAddingToCart() {
        this.elements.wrapper.addClass('sticky-add-to-basket__wrapper--adding-to-cart');
        this.elements.submit.text(this.elements.submit.data('adding-to-basket-text'));
    }

    restoreDefaultState() {
        this.elements.wrapper.removeClass('sticky-add-to-basket__wrapper--adding-to-cart');
        this.elements.submit.text(this.elements.submit.data('detault-text'));
    }

    setEventListeners() {
        this.elements.quantityInput.on(
            'change',
            () => {
                this.shopifyProductForm.setQuantity(parseInt(this.elements.quantityInput.val()));
            }
        );
        this.elements.decrementQuantity.on(
            'click',
            () => {
                this.shopifyProductForm.decrementQuantity();
            }
        );
        this.elements.incrementQuantity.on(
            'click',
            () => {
                this.shopifyProductForm.incrementQuantity();
            }
        );
        jQuery(document).on(
            'shopify-product-form-quantity-update',
            () => {
                this.elements.quantityInput.val(this.shopifyProductForm.getQuantity());
            }
        );
        this.elements.submit.on(
            'click',
            () => {
                this.shopifyProductForm.addToCart();
            }
        );
        BoosterTheme.cart.events.on(
            'booster:cart:b*add',
            () => {
                this.setStateToAddingToCart();
            }
        );
        BoosterTheme.cart.events.on(
            'booster:cart:add',
            () => {
                this.restoreDefaultState();
            }
        );
    }

}

jQuery(document).ready(
    async () => {
        await new Promise(
            (resolve) => {
                let i = setInterval(
                    () => {
                        if(typeof BoosterTheme == 'undefined') {
                            return;
                        }

                        clearInterval(i);
                        resolve();
                    },
                    10
                );
            }
        );

        jQuery('.sticky-add-to-basket__wrapper').each(
            function() {
                new StickyAddToBasket(jQuery(this));
            }
        );
    }
);
